import { DialogRef } from '@angular/cdk/dialog';
import { ChangeDetectionStrategy, Component, HostListener, inject } from '@angular/core';
import { OiqImagePreviewZoomComponent } from '@v2/shared/components/image-preview-zoom/image-preview-zoom.component';
import { TruncateFilenamePipe } from '@v2/shared/pipes/truncate-filename.pipe';
import {
  EMAIL_PNG_PREVIEW_DIALOG_STORE,
  EMAIL_PNG_PREVIEW_DIALOG_STORE_PROVIDER,
} from './email-png-preview-dialog.store';

// Added next to `oiq-ui-dialog` so the dialog styles can drop its light modal surface
export const EMAIL_PNG_PREVIEW_DIALOG_PANEL_CLASS = 'email-png-preview-dialog-panel';

@Component({
  selector: 'oiq-email-png-preview-dialog',
  standalone: true,
  imports: [OiqImagePreviewZoomComponent, TruncateFilenamePipe],
  templateUrl: './email-png-preview-dialog.component.html',
  styleUrl: './email-png-preview-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [EMAIL_PNG_PREVIEW_DIALOG_STORE_PROVIDER],
  host: { class: 'block h-full' },
})
export class EmailPngPreviewDialogComponent {
  private dialogRef = inject(DialogRef);
  readonly store = inject(EMAIL_PNG_PREVIEW_DIALOG_STORE);

  @HostListener('document:keydown.arrowleft')
  onArrowLeft(): void {
    this.store.previous();
  }

  @HostListener('document:keydown.arrowright')
  onArrowRight(): void {
    this.store.next();
  }

  // Like Gmail: a click on the dark area around the page closes the viewer. The dialog
  // covers the whole viewport, so there's no CDK backdrop to click on.
  onBackgroundClick(event: MouseEvent): void {
    const target = event.target as Element;
    if (target.closest('img, button, a, header, .container-header')) return;

    this.close();
  }

  close(): void {
    this.dialogRef.close();
  }
}
